export enum AnalyticsDevFlag {
  AtsBasicCandidateFields = 'ats_basic_candidate_fields',

  HrCustomFields = 'hr_custom_fields',

  FreshDashboards = 'fresh_dashboards',

  HrDetails = 'hr_details',
}

export type AnalyticsDevFlagsMap = Record<AnalyticsDevFlag, boolean>;

export type AnalyticsDevFlagsFetchResponse = {
  features: AnalyticsDevFlag[];
};
